import { label } from "aws-amplify";
import { BRAND_ASSETS, PRODUCT_ASSETS } from "./constants";

export const tabOptions = [
  {
    key: "focus-category",
    href: "#focus-category",
    title: "Focus Category",
  },
  {
    key: "channel-and-capabilities",
    href: "#channel-and-capabilities",
    title: "Channel & Capabilities",
  },
  {
    key: "engagement-terms",
    href: "#engagement-terms",
    title: "Engagement Terms",
  },
];

export const healthOptions = [
  "Vitamins & Minerals",
  "Sports & Fitness Supplements",
  "Men's Health",
  "Digestive Health",
  "Herbal & Natural Supplements",
  "Weight Management",
  "Mental Health & Sleep Support",
  "Heart & Cardiovascular Health",
  "Immune Support & Wellness",
  "Women's Health",
  "Other",
];

export const beautyOptions = [
  "Skincare",
  "Body Care",
  "Wellness & Inner Beauty",
  "Dermatology & Treatments",
  "Other",
];

export const functionalFoodBeveragesOptions = [
  "Bars",
  "Snacking",
  "None",
  "Ready To Mix Beverages",
  "Replacement Meals",
  "RTD Beverages",
  "Other",
];

export const petNutritionOptions = [
  "Dental",
  "Food",
  "Supplements",
  "Snacking",
  "Other",
];

export const channelOptions = [
  "Offline Retail",
  "Food Service/Out of Home",
  "Online",
  "None",
];

export const keyCapabilitiesOptions = [
  "Regulatory Compliance",
  "Distribution",
  "Sales",
  "Importation & Clearance",
  "Marketing",
  "Warehousing",
];

export const warehousingOptions = ["Cold & Frozen", "Ambient"];

export const valueOptions = [
  "Brand Sourcing",
  "Develop Inhouse Brands",
  "Expand Existing Brands to New Markets",
  "Other",
];

export const financialOptions = [
  "None",
  "Financing (eg:Inventory)",
  "Capital (Equity/Debt)",
  "Other",
];

export const materialLightColors: any = {
  A: "#F44336", // Red 500
  B: "#E91E63", // Pink 500
  C: "#9C27B0", // Purple 500
  D: "#673AB7", // Deep Purple 500
  E: "#3F51B5", // Indigo 500
  F: "#2196F3", // Blue 500
  G: "#03A9F4", // Light Blue 500
  H: "#00BCD4", // Cyan 500
  I: "#009688", // Teal 500
  J: "#4CAF50", // Green 500
  K: "#8BC34A", // Light Green 500
  L: "#CDDC39", // Lime 500
  M: "#FFEB3B", // Yellow 500
  N: "#FFC107", // Amber 500
  O: "#FF9800", // Orange 500
  P: "#FF5722", // Deep Orange 500
  Q: "#795548", // Brown 500
  R: "#9E9E9E", // Grey 500
  S: "#607D8B", // Blue Grey 500
  T: "#F06292", // Pink A200
  U: "#BA68C8", // Purple A200
  V: "#9575CD", // Deep Purple A200
  W: "#7986CB", // Indigo A200
  X: "#64B5F6", // Blue A200
  Y: "#4DD0E1", // Cyan A200
  Z: "#81C784"  // Green A200
};

export const assetTypes = [
  {
    label: "Brand Assets",
    value: BRAND_ASSETS
  },
  {
    label: "Product Assets",
    value: PRODUCT_ASSETS
  }
]




export const productCategories = [
  {
    text: "Health Supplements",
    value: "Health Supplements"
  },
  {
    text: "Beauty & Skin",
    value: "Beauty & Skin"
  },
  {
    text: "Functional Food & Beverages",
    value: "Functional Food & Beverages"
  },
  {
    text: "Pet Nutrition",
    value: "Pet Nutrition"
  },
];

export const productSubCategories = [
  // Health Supplements
  { value: "Vitamins & Minerals", text: "Vitamins & Minerals", category: "Health Supplements" },
  { value: "Sports & Fitness Supplements", text: "Sports & Fitness Supplements", category: "Health Supplements" },
  { value: "Men’s Health", text: "Men’s Health", category: "Health Supplements" },
  { value: "Digestive Health", text: "Digestive Health", category: "Health Supplements" },
  { value: "Herbal & Natural Supplements", text: "Herbal & Natural Supplements", category: "Health Supplements" },
  { value: "Weight Management", text: "Weight Management", category: "Health Supplements" },
  { value: "Mental Health & Sleep Support", text: "Mental Health & Sleep Support", category: "Health Supplements" },
  { value: "Heart & Cardiovascular Health", text: "Heart & Cardiovascular Health", category: "Health Supplements" },
  { value: "Immune Support & Wellness", text: "Immune Support & Wellness", category: "Health Supplements" },
  { value: "Women’s Health", text: "Women’s Health", category: "Health Supplements" },
  { value: "Other", text: "Other", category: "Health Supplements" },

  // Beauty & Skin
  { value: "Skincare", text: "Skincare", category: "Beauty & Skin" },
  { value: "Body Care", text: "Body Care", category: "Beauty & Skin" },
  { value: "Wellness & Inner Beauty", text: "Wellness & Inner Beauty", category: "Beauty & Skin" },
  { value: "Dermatology & Treatments", text: "Dermatology & Treatments", category: "Beauty & Skin" },
  { value: "Other", text: "Other", category: "Beauty & Skin" },

  // Functional Food & Beverages
  { value: "Bars", text: "Bars", category: "Functional Food & Beverages" },
  { value: "Snacking", text: "Snacking", category: "Functional Food & Beverages" },
  { value: "None", text: "None", category: "Functional Food & Beverages" },
  { value: "Ready To Mix Beverages", text: "Ready To Mix Beverages", category: "Functional Food & Beverages" },
  { value: "Replacement Meals", text: "Replacement Meals", category: "Functional Food & Beverages" },
  { value: "RTD Beverages", text: "RTD Beverages", category: "Functional Food & Beverages" },
  { value: "Other", text: "Other", category: "Functional Food & Beverages" },

  // Pet Nutrition
  { value: "Dental", text: "Dental", category: "Pet Nutrition" },
  { value: "Food", text: "Food", category: "Pet Nutrition" },
  { value: "Supplements", text: "Supplements", category: "Pet Nutrition" },
  { value: "Snacking", text: "Snacking", category: "Pet Nutrition" },
  { value: "Other", text: "Other", category: "Pet Nutrition" },
];

export const marketOptions = [
  { value: "Australia", label: "Australia" },
  { value: "China", label: "China" },
  { value: "Hong Kong", label: "Hong Kong" },
  { value: "India", label: "India" },
  { value: "Indonesia", label: "Indonesia" },
  { value: "Japan", label: "Japan" },
  { value: "Malaysia", label: "Malaysia" },
  { value: "Philippines", label: "Philippines" },
  { value: "S. Korea", label: "S. Korea" },
  { value: "Singapore", label: "Singapore" },
  { value: "South Korea", label: "South Korea" },
  { value: "Taiwan", label: "Taiwan" },
  { value: "Thailand", label: "Thailand" },
  { value: "Vietnam", label: "Vietnam" },
];

export const adversoryTypeOptions = [
  {
    label: "Market Intelligence Report",
    value: "Market Intelligence Report"
  }
]

export const adversorySubTypeOptions = [
  {
    text: "Market Insights Report",
    value: "Market Insights Report"
  },
  {
    text: "Market Readiness Report",
    value: "Market Readiness Report"
  },
  {
    text: "Market Rollout Report",
    value: "Market Rollout Report"
  },
]

export const marketingInvestmentOptions = [
  "Brand Responsibility",
  "Partner Responsibility",
  "Co-Responsibility",
  "Other"
]

export const marketplacesOptions = [
  { value: 'Brand eShop', label: 'Brand eShop' },
  { value: 'Alibaba', label: 'Alibaba' },
  { value: 'Amazon ', label: 'Amazon ' },
  { value: 'AliExpress', label: 'AliExpress' },
  { value: 'JD.com', label: 'JD.com' },
  { value: 'Tmall', label: 'Tmall' },
  { value: 'Pinduoduo', label: 'Pinduoduo' },
  { value: 'Lazada', label: 'Lazada' },
  { value: 'Shopee', label: 'Shopee' },
  { value: "eBay", label: "eBay" },
  { value: 'Tokopedia', label: 'Tokopedia' },
  { value: 'Bukalapak', label: 'Bukalapak' },
  { value: 'Tiki', label: 'Tiki' },
  { value: 'Sendo', label: 'Sendo' },
  { value: 'Qoo10', label: 'Qoo10' },
  { value: 'Flipkart', label: 'Flipkart' },
  { value: 'Snapdeal', label: 'Snapdeal' },
  { value: 'Myntra', label: 'Myntra' },
  { value: 'Nykaa', label: 'Nykaa' },
  { value: 'Rakuten', label: 'Rakuten' },
  { value: 'Mercari', label: 'Mercari' },
  { value: 'Coupang', label: 'Coupang' },
  { value: 'Gmarket', label: 'Gmarket' },
  { value: 'Taobao', label: 'Taobao' },
  { value: 'Xiaohongshu (Little Red Book)', label: 'Xiaohongshu (Little Red Book)' },
  { value: 'WeChat Mini Stores', label: 'WeChat Mini Stores' },
  { value: 'Other', label: 'Other' },
];

export const businessModelOptions = [
  { label: "Pre-Purchase", value: "Pre-Purchase" },
  { label: "Consignment", value: "Consignment" },
  { label: "Both", value: "Both" }
];

export const tradingTermsOptions = [
  { label: "Exclusive", value: "Exclusive" },
  { label: "Non - Exclusive", value: "Non - Exclusive" },
  { label: "Both", value: "Both" }
];

export const exclusivityTenureOptions = [
  { label: "1 year", value: "1 year" },
  { label: "2 years", value: "2 years" },
  { label: "3 years", value: "3 years" },
  { label: "4 years", value: "4 years" },
  { label: "5 years", value: "5 years" },
  { label: "Other", value: "Other" },
];

export const marketingInvestmentOptionsList = [
  { label: "Brand Responsibility", value: "Brand Responsibility" },
  { label: "Partner Responsibility", value: "Partner Responsibility" },
  { label: "Co-Responsibility", value: "Co-Responsibility" },
  { label: "Other", value: "Other" }
];

export const paymentTermsOptionsList = [
  { label: "COD", value: "COD" },
  { label: "Bank LC", value: "Bank LC" },
  { label: "30-60 Days Credit", value: "30-60 Days Credit" },
  { label: "Escrow", value: "Escrow" }
];


export const discoverStatusListPartner = [
  // {
  //   text: "Pending",
  //   value: "Open"
  // },
  {
    text: "Interest Expressed",
    value: "interest expressed"
  },
  {
    text: "Interest Accepted",
    value: "interest accepted"
  },
  {
    text: "Skipped",
    value: "skipped"
  },
]

export const discoverStatusListBrand = [
  {
    text: "Pending",
    value: "Open"
  },
  {
    text: "Interest Received",
    value: "Interest Expressed"
  },
  {
    text: "Interest Accepted",
    value: "Interest Accepted"
  },
]